import { CountryEnum } from "@/lib/supabase/supabaseEnums";
import { isIBANValid } from "../../pdf-templates/pdf-template-components/qr-payment-slip/qr-payment-validation-functions";
import { validateEmail } from "../../hooks/useForm/form-field-validation-functions";

const SWISS_OR_GERMAN_MWST_REGEX =
	/^(CHE[- ]?\d{3}(\.\d{3}){2}( MWST)?|DE[- ]?\d{3}(\.\d{3}){2})$/;
// Liechtenstein still issues 5-digit MWST numbers (e.g. 12345 or 12.345)
const LIECHTENSTEIN_MWST_REGEX = /^\d{2}\.?\d{3}$/;

export const validateMwstNumber = (
	mwst: string,
	country?: string | null
): boolean => {
	if (!mwst) return false;
	const isLiechtensteinNumber =
		country === CountryEnum.LIECHTENSTEIN &&
		LIECHTENSTEIN_MWST_REGEX.test(mwst);
	return isLiechtensteinNumber || SWISS_OR_GERMAN_MWST_REGEX.test(mwst);
};

export const validateIban = (iban: string): boolean => {
	if (!iban) return false; // Required when not using PC account
	// Remove whitespace before validation
	const cleanedIban = iban.replace(/\s/g, "");
	return isIBANValid(cleanedIban);
};

export const validateGLN = (gln: string): boolean => {
	if (!gln) return true; // Optional field
	const glnRegex = /^\d{13}$/;
	return glnRegex.test(gln);
};

export const validateActivationCode = (code: string): boolean => {
	return code.trim().length > 0;
};

export const validateReferenceNumber = (referenceNumber: string): boolean => {
	const referenceNumberRegex = /^\d{13}$/;
	return referenceNumberRegex.test(referenceNumber);
};

export const validatePasswordStrength = (password: string): {
	score: number;
	color: string;
	label: string;
} => {
	let score = 0;
	const hasLowercase = /[a-z]/;
	const hasUppercase = /[A-Z]/;
	const hasNumber = /[0-9]/;
	const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

	if (password.length >= 6) score++;
	if (hasLowercase.test(password)) score++;
	if (hasUppercase.test(password)) score++;
	if (hasNumber.test(password)) score++;
	if (hasSpecialChar.test(password)) score++;

	const colors = ["error", "error", "warning", "warning", "info", "success"];
	const labels = [
		"Sehr schwach",
		"Schwach",
		"Fair",
		"Mittel",
		"Stark",
		"Sehr stark",
	];

	return {
		score,
		color: colors[score],
		label: labels[score],
	};
};

export { validateEmail };
